import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #d8d8da;
`;

export const SecondContainer = styled.div`
  display: flex;
`;
